<template>
    <form class="rf-view sign-up-view" @submit.prevent="submit">
        <NavigationBar :title="$t('buttons.signUp')">
            <BackButton v-if="canPop" slot="left" @click="pop" />
        </NavigationBar>
        <main>
            <h1>
                {{ $t('buttons.signUp') }}
            </h1>

            <GeneralErrorsView :error-box="errorBox" />

            <InputBox :title="$t('fields.email')" :error-box="errorBox" error-fields="email">
                <input v-model="email" class="input" :placeholder="$t('fields.placeholders.email')" autocomplete="username" type="email">
            </InputBox>

            <InputBox :title="$t('fields.password')" :error-box="errorBox" error-fields="password">
                <input v-model="password" class="input" :placeholder="$t('fields.placeholders.password')" autocomplete="new-password" type="password">
            </InputBox>

            <InputBox :title="$t('fields.repeatPassword')" :error-box="errorBox" error-fields="passwordRepeat">
                <input v-model="repeatPassword" class="input" :placeholder="$t('fields.placeholders.repeatPassword')" autocomplete="new-password" type="password">
            </InputBox>

            <Checkbox v-model="emailCanBeShared" :error-box="errorBox" error-fields="emailCanBeShared">
                {{ $t('fields.emailCanBeShared') }}
            </Checkbox>
        </main>

        <FloatingFooter class="noSticky">
            <LoadingButton :loading="loading" class="block">
                <button class="button primary full">
                    {{ $t('buttons.signUp') }}
                </button>
            </LoadingButton>
        </FloatingFooter>
    </form>
</template>


<script lang="ts">
import { BackButton,Checkbox,FloatingFooter, InputBox, LoadingButton, NavigationBar } from "@restofrit/components"
import { NetworkManager, Session } from "@restofrit/networking";
import { Language, Token } from "@restofrit/structures";
import { ErrorBox, GeneralErrorsView } from "@simonbackx/simple-error-forms";
import { SimpleError } from "@simonbackx/simple-errors";
import { HistoryManager, NavigationMixin } from "@simonbackx/vue-app-navigation";
import { Component, Mixins } from "vue-property-decorator";

@Component({
    components: {
        Checkbox,
        InputBox,
        GeneralErrorsView,
        LoadingButton,
        FloatingFooter,
        NavigationBar,
        BackButton
    },
})
export default class SignUpView extends Mixins(NavigationMixin) {
    errorBox: ErrorBox | null = null
    email = ""
    password = ""
    repeatPassword = ""
    emailCanBeSharedStatus = false
    loading = false

    mounted() {
        HistoryManager.setUrl("/register");
    }

    get emailCanBeShared() {
        return this.emailCanBeSharedStatus
    }

    set emailCanBeShared(emailCanBeShared: boolean) {
        this.emailCanBeSharedStatus = emailCanBeShared
    }

    async submit() {
        if (this.loading) {
            return
        }
        this.loading = true
        this.errorBox = null

        try {
            if (this.password != this.repeatPassword) {
                throw new SimpleError({
                    code: "invalid_field",
                    message: this.$t('errors.repeatPassword').toString(),
                    field: "repeatPassword"
                })
            }
            if (this.password.length < 8) {
                throw new SimpleError({
                    code: "invalid_field",
                    message: this.$t('errors.passwordTooShort').toString(),
                    field: "password"
                })
            }

            // Set language to browser language
            const language = navigator.language ?? Language.en;

            if (this.emailCanBeSharedStatus == false) {
                throw new SimpleError({
                    code: "email_opt_in",
                    message: this.$t('errors.emailCanBeSharedRequired').toString(),
                    field: "emailCanBeShared"
                })
            }

            const response = await NetworkManager.server.request({
                method: "POST",
                path: "/auth/create-user",
                body: {
                    email: this.email,
                    password: this.password,
                    emailCanBeShared: this.emailCanBeSharedStatus,
                    language: language
                },
                decoder: Token
            })
            await Session.shared.setToken(response.data)
        } catch (e) {
            this.errorBox = new ErrorBox(e)
        }
        this.loading = false
    }
    
}
</script>